import { conclusionRoutesWithHeader, conclusionRoutesWithoutHeader } from './conclusionRoutes';
import amountExamsRoutes from './amountExamsRoutes';
import errorRoutes from './errorRoutes';
import examRoutes from './examRoutes';
import patientDataRoutes from './patientDataRoutes';
import paymentRoutes from './paymentRoutes';
import questionnaireRoutes from './questionnaireRoutes';
import queueRoutes from './queueRoutes';

import { healthInsuranceNoHeader } from './paymentRoutes/healthInsurance';
import publicRoutes from './publicRoutes';
import signatureRoutes from './signatureRoutes';
import professionalRoutes from './professionalRoutes';

export const pages = [
  ...amountExamsRoutes,
  ...errorRoutes,
  ...examRoutes,
  ...patientDataRoutes,
  ...paymentRoutes,
  ...signatureRoutes,
  ...questionnaireRoutes,
  ...queueRoutes,
  ...conclusionRoutesWithHeader,
  ...professionalRoutes,
];

export const pagesWithoutHeader = [
  ...healthInsuranceNoHeader,
  ...conclusionRoutesWithoutHeader,
  ...publicRoutes,
];
